<template>
  <q-list
    bordered
    separator
  >
    <q-item
      class="text-subtitle2 q-py-sm items-center"
      dense
    >
      <q-icon
        v-if="icon"
        :name="icon"
        class="q-mr-sm"
        size="sm"
      />
      {{ title }}
      <q-space />
      <q-btn
        v-if="showEditButton"
        icon="edit"
        flat
        round
        size="sm"
        dense
        @click="$emit('edit')"
      >
        <q-tooltip>Edit {{ title }}</q-tooltip>
      </q-btn>
    </q-item>
    <transition-group name="list-complete">
      <template v-if="Object.keys(items).length">
        <template
          v-for="(categoryItems, category) in items"
          :key="category"
        >
          <div>
            <q-item
              v-if="!hideCategory"
              class="bg-grey-1"
            >
              <q-item-section>
                <q-item-label class="text-uppercase text-weight-medium">
                  {{ category }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </div>
          <div
            v-for="item in categoryItems"
            :key="item.field"
          >
            <q-item>
              <q-item-section>
                <q-item-label lines="1">
                  {{ item.label }}
                </q-item-label>
                <q-item-label
                  v-if="item.definition"
                  caption
                >
                  {{ item.definition }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </div>
        </template>
      </template>
      <div
        v-else
        :key="'empty'"
      >
        <q-item>
          <q-item-section>
            <q-item-label class="text-grey-7">
              {{ emptyMessage }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </div>
    </transition-group>
  </q-list>
</template>

<script>
export default {
  name: 'CategoryList',
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    emptyMessage: {
      type: String,
      default: 'No items available'
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    showEditButton: {
      type: Boolean,
      required: false,
      default: false
    },
    hideCategory: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['edit']
}
</script>
